import { useMemo } from "react";
import shallow from "zustand/shallow";
import { useStoreRoom } from "../store";

export const useRoomSizes = () => {

   const { roomLength, roomDepth, roomHeight } = useStoreRoom((state) => ({
      roomLength: state.length,
      roomDepth: state.depth,
      roomHeight: state.height,
   }), shallow);

   const roomSizes = useMemo(() => ({ width: roomLength, height: roomHeight, depth: roomDepth }), [roomLength, roomHeight, roomDepth]);

   return {
      roomLength,
      roomHeight,
      roomSizes,
      roomDepth,
   };
};
